import { useTranslation } from "react-i18next";

export function CharacterCount({
    currentLength,
    maxLength,
}: {
    currentLength: number;
    maxLength: number;
}) {
    const { t } = useTranslation();

    return (
        <div className="text-compendia-muted self-end text-sm">
            {t("common.characterCount", {
                current: currentLength,
                max: maxLength,
            })}
        </div>
    );
}
